
import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { api } from '../helper/api.interceptor';

const SignInLayer = ({ setSession }) => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        username: '',
        password: ''
    });
    const [rememberMe, setRememberMe] = useState(false);
    const [passwordVisible, setPasswordVisible] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (Object.values(formData).every(item => item.toString().trim().length > 0)) {
            if (true) {
                await api.signInSuperAdmin(formData).then(dt => {
                    console.log(dt);


                    if (dt?.result?.token) {
                        if (rememberMe) {
                            console.log(rememberMe);

                            // persist token even after browser closes
                            localStorage.setItem('token', dt.result.token);
                            localStorage.setItem('userId', dt.result.admin_id);
                        } else {
                            // only for this session
                            sessionStorage.setItem('token', dt.result.token);
                            sessionStorage.setItem('userId', dt.result.admin_id);
                        }

                        setSession(dt.result.token);
                        navigate('/');
                    } else {
                        alert("Invalid Credentials");
                    }


                })

            } else {
                alert('Invalid user');
            }
        }
    };

    const togglePasswordVisibility = () => {
        setPasswordVisible(prevState => !prevState);
    };

    return (
        <section className="auth bg-base d-flex flex-wrap">
            <div className="auth-left d-lg-block d-none">
                <div className="d-flex align-items-center flex-column h-100 justify-content-center">
                    <img src="duccasso\blog-detail-image.webp" alt="Farmer img" width="951" height="100" />
                </div>
            </div>
            <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
                <div className="max-w-464-px mx-auto w-100">
                    <div>
                        <Link to="#" className="mb-40 max-w-290-px">
                            <img src="duccasso/site-logo.63e08056.svg" alt="entaj-logo" width={250} height={65} />
                        </Link>
                        <h4 className="mb-12">Sign In to your Account</h4>
                        <p className="mb-32 text-secondary-light text-lg">
                            Welcome back! please enter your detail
                        </p>
                    </div>
                    <form action="#" onSubmit={handleSubmit}>
                        <div className="icon-field mb-16">
                            <span className="icon top-50 translate-middle-y">
                                <Icon icon="mage:email" />
                            </span>
                            <input
                                type="text"
                                className="form-control h-56-px bg-neutral-50 radius-12 logininput"
                                placeholder="UserName"
                                name="username"
                                value={formData.username}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="position-relative mb-20">
                            <div className="icon-field">
                                <span className="icon top-50 translate-middle-y">
                                    <Icon icon="solar:lock-password-outline" />
                                </span>
                                <input
                                    type={passwordVisible ? 'text' : 'password'} // Toggle between text and password type
                                    className="form-control h-56-px bg-neutral-50 radius-12 logininput"
                                    id="your-password"
                                    placeholder="password"
                                    name="password"
                                    value={formData.password}
                                    onChange={handleChange}
                                />
                            </div>
                            <span
                                className="toggle-password ri-eye-line cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light"
                                onClick={togglePasswordVisibility} // Toggle password visibility when clicked
                            />
                        </div>
                        <div className="">
                            <div className="d-flex justify-content-between gap-2">
                                <div className="form-check style-check d-flex align-items-center">
                                    <input
                                        className="form-check-input border border-neutral-300"
                                        type="checkbox"
                                        id="remember"
                                        checked={rememberMe}
                                        onChange={(e) => setRememberMe(e.target.checked)}
                                    />
                                    <label className="form-check-label" htmlFor="remember">
                                        Remember me
                                    </label>
                                </div>
                                {/* <Link to="#" className="text-primary-600 fw-medium">
                                    Forgot Password?
                                </Link> */}
                            </div>
                        </div>
                        <button
                            type="submit"
                            className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
                        >
                            {" "}
                            Sign In
                        </button>
                    </form>
                </div>
            </div>
        </section>
    );
};

export default SignInLayer;
